@if (visible$ | async) {
  <div class="pnkl-spinner overlay"></div>
}
